import { CommonModule } from '@angular/common';
import { fullHeightModule } from './../../directives/fullHeight.module';
import { SigninComponent } from './signin/signin.component';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { AuthentificationComponent } from './authentification.component';
import { SignupComponent } from './signup/signup.component';
import { ConfirmationAccountComponent } from './confirmation-account/confirmation-account.component';
import { ForgetpasswordComponent } from './forgetpassword/forgetpassword.component';
import { routing } from './authentication.routing';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        fullHeightModule,
        routing
    ],
    declarations: [
        AuthentificationComponent,
        SignupComponent,
        SigninComponent,
        ConfirmationAccountComponent,
        ForgetpasswordComponent
    ],
    exports: [
        AuthentificationComponent,
        SigninComponent
    ]
})
export class AuthentificationModule {

}
